<template>
    <v-app> 
         <Tabs :routes='route' colors="#a21706" />
            <v-container>
                <transition name="slide-fade">
                 <router-view></router-view>
                </transition>
            </v-container>
            <Menu type="vehiculo"/>     
              
        </v-app>
</template>
<script>

import Tabs from '../../component/layouts/content/tabs'
import Menu from '../../component/layouts/single'

export default {
    components:{
        Tabs,
        Menu
    },

    mounted() {
        this.GetVehicles();
    },

    methods: {
        GetVehicles:function(){
            this.$store.dispatch('LoadingAction');
            this.$store.dispatch('GetVehicles');
        }
    },

    computed: {
        
        

    },

    data(){
        return {

            route:[
                {
                    id:1,
                    name:'Lista de vehículos',
                    icon:'mdi-table-large',
                    route:'/vehiculo',
                    items: [
                        {
                        text: 'Inicio',
                        disabled: false,
                        href: '/',
                        },
                        {
                        text: 'Vehículo',
                        disabled: true,
                        href: 'Vehiculo',
                        },
                        
                    ],
                
                },

                {
                    id:2,
                    name:'Crear vehículos',
                    icon:'mdi-car',
                    route:'/vehiculo/crear',
                    items: [
                        {
                        text: 'Inicio',
                        disabled: false,
                        href: '/',
                        },
                        {
                        text: 'Vehiculo',
                        disabled: false,
                        href: '/Vehiculo',
                        },
                        {
                        text: 'Crear',
                        disabled: true,
                        href: '/Vehiculo/crear',
                        },
                        
                    ],

                },
            ]

        }
    }

  }
</script>